import { FormattedMessage } from 'react-intl';

import { Switch } from '@sorare/core/src/atoms/inputs/Switch';
import { Horizontal, SBHorizontal } from '@sorare/core/src/atoms/layout/flex';
import { LabelM } from '@sorare/core/src/atoms/typography';
import { useShortcutWithKeys } from '@sorare/core/src/hooks/useShortcutWithKeys';

type Props = {
  includeUnavailablePlayers: boolean;
  setIncludeUnavailablePlayers: (includeUnavailablePlayers: boolean) => void;
};

export const IncludeUnavailablePlayersFilter = ({
  includeUnavailablePlayers,
  setIncludeUnavailablePlayers,
}: Props) => {
  const id = 'include-unavailable';

  const { Icon: UnavailableShortcutIcon } = useShortcutWithKeys(
    'x',
    () => setIncludeUnavailablePlayers(!includeUnavailablePlayers),
    [includeUnavailablePlayers]
  );

  return (
    <SBHorizontal>
      <Horizontal>
        <LabelM color="var(--c-nd-600)" as="label" htmlFor={id}>
          <FormattedMessage defaultMessage="Suspended/Injured" />
        </LabelM>
        {UnavailableShortcutIcon}
      </Horizontal>
      <Switch
        id={id}
        checked={includeUnavailablePlayers}
        onChange={e => setIncludeUnavailablePlayers(e.target.checked)}
      />
    </SBHorizontal>
  );
};
